import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface CounterState {
  count: number
}

const initialState: CounterState = {
  count: 0,
}

export const Slice = createSlice({
  name: 'counter',
  initialState,
  reducers: {

    countSet: (state, action) => {
      const { count } = action.payload;
      state.count = count;

    }
  },
})

// Action creators are generated for each case reducer function
export const { countSet } = Slice.actions

export default Slice.reducer